import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { CrudStore } from 'core/types/crudStore'

export const removeQueries = (crudKey?: string) => {
  const sourceExt = CrudStore.get(CrudStoreItem.ContactExt, `contact-list ${crudKey}`)
  const sourceOpened = CrudStore.get(CrudStoreItem.OpenedContactRequests, `contact-list ${crudKey}`)
  const sourceAll = CrudStore.get(CrudStoreItem.ContactAllData, `contact-list ${crudKey}`)
  sourceExt.removeQueries(true)
  sourceOpened.removeQueries(true)
  sourceAll.removeQueries(true)
}
